<template>
  <div class="jl-lunbo">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in banners" :key="item.id">
          <a :href="item.link" class="banner-box">
            <div
              class="focuspoint"
              data-focus-x="0"
              data-focus-y="0"
              data-image-w="1920"
              data-image-h="800"
            >
              <img :src="item.imgUrl" />
            </div>
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/idangerous.swiper.min.js";
import "swiper/dist/idangerous.swiper.css";

export default {
  props: {
    banners: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  updated() {
    new Swiper(".jl-lunbo .swiper-container", {
      loop: true,
      autoplay: 4000,
      speed: 1200,
      updateOnImagesReady: true,
      autoplayDisableOnInteraction: false,
      pagination: ".jl-lunbo .swiper-pagination",
      paginationClickable: true
    });
    $(".focuspoint").focusPoint();
  }
};
</script>

<style lang="scss">
.banner-box {
  display: block;
  height: 100%;
  div {
    height: 100%;
  }
}
.jl-lunbo {
  height: 100%;

  .swiper-container {
    height: 100%;

    .swiper-slide {
      height: 100%;
    }
    .swiper-pagination {
      position: absolute;
      z-index: 100;
      bottom: 30px;
      width: 100%;
      text-align: center;

      .swiper-pagination-switch {
        display: inline-block;
        width: 28px;
        height: 2px;
        border-radius: 8px;
        background: #fff;
        margin: 0 5px;
        opacity: 0.5;
        cursor: pointer;

        &.swiper-active-switch {
          background: #e60012;
          opacity: 1;
        }
      }
    }
  }
}
</style>

